import { jsx as s } from "react/jsx-runtime";
import l, { createContext as C } from "react";
const c = C();
function f(n) {
  return typeof n == "function";
}
function d(n) {
  return typeof n == "object" && !j(n) && !y(n);
}
function j(n) {
  return Array.isArray(n);
}
function y(n) {
  return n === null;
}
function b(n = {}, t = !1, e = {}) {
  if (!t)
    return e;
  let o = {};
  const r = f(t) ? t(n) : n[t];
  return d(r) ? Object.assign(o, r, e) : f(r) ? Object.assign(o, e, r(e, n)) : Object.assign(o, e), o;
}
const h = (n) => ({ Context: c, Provider: ({ children: r, ...i }) => /* @__PURE__ */ s(c.Provider, { value: { ...n, ...i }, children: r }), Consumer: (r) => (i) => /* @__PURE__ */ s(c.Consumer, { children: (u) => /* @__PURE__ */ s(r, { ...u, ...i, context: u }) }), Component: (r, i = r.displayName || r.name) => l.forwardRef(
  (u, m) => /* @__PURE__ */ s(c.Consumer, { children: (a) => /* @__PURE__ */ s(r, { ...b(a, i, u), ref: m }) })
) }), g = h(), P = g.Component;
export {
  g as Theme,
  P as Themed,
  h as Themer
};
//# sourceMappingURL=react-one-louder.js.map
